import { Component, OnInit } from '@angular/core';
import { AARoutePlannerEvents } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { RoutePlannerOptionsData } from '../../models/route-model';
import { RoutePlannerService } from '../../services/route-planner/route-planner.service';
import { RouteOptionsService } from '../../services/route-options/route-options.service';
import { AppService } from 'src/app/modules/aa-core/services/app-service/app.service';

@Component({
    selector: 'aa-route-options',
    templateUrl: './route-options.component.html',
    styleUrls: ['./route-options.component.scss'],
    standalone: false
})
export class RouteOptionsComponent implements OnInit {

  public routeOptionsData: RoutePlannerOptionsData;

  constructor(private eventsService: EventsService,
    private appService: AppService,
    private routeOptionsService: RouteOptionsService,
    private routePlanerService: RoutePlannerService) {}
    public viaLocationMessage: string;

  ngOnInit() {
    this.routeOptionsData = this.routePlanerService.routeDataModel.OptionsData;
  }

  toggleOptionPanel() {
    this.appService.trackingAndSeoService.link({
        event_category: 'Route Planner',
        event_name: 'Options - button clicked',
    });

    this.routeOptionsData.ToggleOptionsPanel = !this.routeOptionsData.ToggleOptionsPanel;
  }

  onAddViaRoute() {
    this.appService.trackingAndSeoService.link({
        event_category: 'Route Planner',
        event_name: 'Via - button clicked',
    });

    this.eventsService.dispatch(AARoutePlannerEvents.ADD_VIA_ROUTE);
  }

  onFocusAvoidMotorway() {
    const el: HTMLElement = document.getElementById('avoidMotorwaysTick');
    el.classList.add('focus');
  }

  onBlurAvoidMotorway() {
    const el: HTMLElement = document.getElementById('avoidMotorwaysTick');
    el.classList.remove('focus');
  }

  onFocusAvoidToll() {
    const el: HTMLElement = document.getElementById('avoidTollTick');
    el.classList.add('focus');
  }

  onBlurAvoidToll() {
    const el: HTMLElement = document.getElementById('avoidTollTick');
    el.classList.remove('focus');
  }

  onFocusAvoidTraffic() {
    const el: HTMLElement = document.getElementById('avoidTollTraffic');
    el.classList.add('focus');
  }

  onBlurAvoidTraffic() {
    const el: HTMLElement = document.getElementById('avoidTollTraffic');
    el.classList.remove('focus');
  }
}
